import { IIngridApi } from '@checkout/state';
import { ingridResume, ingridSuspend } from './../../../utils/widgets';

interface IData {
  additionalFields: {
    event: string;
    suspendIgnore: {
      shipwallet: boolean;
    };
  };
  address?: {
    zipCode: string;
  };
}

interface ISuspendIgnore { shipwallet: boolean; }

const CentraCheckoutScript = () => {
  const suspend = function(suspendIgnore: ISuspendIgnore): void {
    const ignoreSuspend = suspendIgnore && suspendIgnore.shipwallet !== undefined && suspendIgnore.shipwallet;
    ingridSuspend(ignoreSuspend);
  };

  const resume = function(suspendIgnore: ISuspendIgnore): void {
    const ignoreSuspend = suspendIgnore && suspendIgnore.shipwallet !== undefined && suspendIgnore.shipwallet;
    ingridResume(ignoreSuspend);
  };

  const sendEvent = (data: IData) => {
    suspend(data.additionalFields.suspendIgnore);
    const event = new CustomEvent('centra_checkout_callback', { detail: data });
    window.dispatchEvent(event);
  };

  const addEvents = function() {
    if (!!window._sw) {
      window._sw(function (api: IIngridApi) {
        api.on('address_changed', (address) => {
          // tslint:disable-next-line:no-console
          console.log('ingrid dispatched event: "address_changed"', address);
          if (address.country && address.postal_code) {
            sendEvent({
              additionalFields: {
                event: 'shipwallet_address_change',
                suspendIgnore: { shipwallet: true },
              },
              address: {
                zipCode: address.postal_code
              }
            });
          }
          // tslint:disable-next-line:no-console
          console.log('address updated:', address);
        });

        api.on('shipping_option_changed', (data) => {
          // tslint:disable-next-line:no-console
          console.log('ingrid dispatched event: "shipping_option_changed"', data);
          sendEvent({
            additionalFields: {
              event: 'shipwallet_address_change',
              suspendIgnore: { shipwallet: true },
            }
          });
        });
      });
    }
  };

  return {
    addEvents,
    suspend,
    resume,
  };
};

export default CentraCheckoutScript;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/container/IngridWidget2/CentraCheckoutScript.ts